import type { IllustrationProps } from './types';
import {
  ILLUSTRATION_PALETTE,
  CarFigure,
  IllustrationSvg,
  SkyBackdrop,
  SlopeSurface,
  WarningDot,
} from './shared';

export default function CarImpossibleIllustration({
  className,
  width,
  height,
  primaryColor,
  accentColor,
}: IllustrationProps) {
  const accent = accentColor ?? ILLUSTRATION_PALETTE.impossible;

  return (
    <IllustrationSvg className={className} width={width} height={height} title="Araç çıkamıyor">
      <SkyBackdrop accent={accent} />
      <SlopeSurface startY={50} endY={12} accent={accent} />
      <CarFigure cx={42} cy={10} tilt={-24} slip primary={primaryColor} />
      <WarningDot x={60} y={8} />
    </IllustrationSvg>
  );
}
